import React from 'react';
import styles from '../asset/scoreStatisticBoard.module.scss';
import DotIndicator from './DotIndicator';

const Milestone = ({ score, label, position, isActive = false }) => (
    <div className={styles.milestone} style={{ left: position }}>
        <span className={styles.milestoneScore}>{score}</span>
        <div className={styles.milestoneIndicator}>
            <DotIndicator count={4} color={isActive ? '#220EC9' : '#4f48ff'} size={isActive ? 6 : 4} />
            <span className={styles.milestoneLabel}>{label}</span>
        </div>
    </div>
);

export default Milestone;
